var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('h1',{staticClass:"title is-1"},[_vm._v("Dashboard")]),_c('hr'),_c('div',{staticClass:"content"},[_c('p',[_vm._v("Comming Soon!")])])])
}]

export { render, staticRenderFns }